import * as React from 'react';
import { useTheme, ThemeProvider } from '@narvar/nth-hook-theme';
import CustomComponentContext from '../CustomComponentContext';

interface TemplateLinkProps {
  children?: React.ReactNode;
  key: string;
  url?: string;
}

const TemplateLink: React.FunctionComponent<TemplateLinkProps> = ({
  children,
  key,
  url,
}) => {
  const { bodytextDefaultNone: linkStyle } = useTheme();

  const { color: linkColor } = linkStyle || {};
  return (
    <a
      style={{
        color: linkColor,
      }}
      key={key}
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
};

const ThemedTemplateLink: React.FunctionComponent<TemplateLinkProps> = (
  props,
) => {
  const { state } = React.useContext(CustomComponentContext);
  const featureName = state?.settings.featureName;
  const featureNameStr = typeof featureName === 'string' ? featureName : '';
  return (
    <ThemeProvider
      featureName={featureNameStr}
      themeTokens={['bodytextDefaultNone']}
    >
      <TemplateLink
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </ThemeProvider>
  );
};

export default ThemedTemplateLink;
